export default {
  root: 'https://api.plunk.io/v1/activity',
  protocol: 'https',
  host: 'api.plunk.io',
  path: '/v1/activity',
  port: 443,
  activity: {
    root: 'https://api.plunk.io/v1/activity',
    protocol: 'https',
    host: 'api.plunk.io',
    path: '/v1/activity',
    port: 443
  },
  audience: {
    root: 'https://api.plunk.io/v1',
    protocol: 'https',
    host: 'api.plunk.io',
    path: '/v1',
    port: 443
  },
  product: {
    root: 'https://api.plunk.io/v1',
    protocol: 'https',
    host: 'api.plunk.io',
    path: '/v1',
    port: 443
  },
  location: {
    root: 'https://api.plunk.io/v1',
    protocol: 'https',
    host: 'api.plunk.io',
    path: '/v1',
    port: 443
  },
  forecast: {
    root: 'https://api.plunk.io/v1',
    protocol: 'https',
    host: 'api.plunk.io',
    path: '/v1',
    port: 443
  },
  assistant: {
    root: 'https://api.plunk.io/v1',
    protocol: 'https',
    host: 'api.plunk.io',
    path: '/v1',
    port: 443
  },
  campaign: {
    root: 'https://campaign.plunk.io/api',
    protocol: 'https',
    host: 'campaign.plunk.io',
    path: '/api',
    port: 443
  },
  research: {
    root: 'https://api.plunk.io/v1/market-research',
    protocol: 'https',
    host: 'api.plunk.io',
    path: '/v1/market-research',
    port: 443
  },
  marketIntelligence: {
    root: 'https://api.plunk.io/v1/market-intelligence',
    protocol: 'https',
    host: 'api.plunk.io',
    path: '/v1/market-intelligence',
    port: 443
  },
  agent: {
    root: 'https://api.plunk.io/v1/agent',
    protocol: 'https',
    host: 'api.plunk.io',
    path: '/v1/agent',
    port: 443
  }
};